import { render, staticRenderFns } from "./breeder-litter-management-component.vue?vue&type=template&id=8a2f6e70&scoped=true&lang=pug"
import script from "./breeder-litter-management-component.js?vue&type=script&lang=js&external"
export * from "./breeder-litter-management-component.js?vue&type=script&lang=js&external"
import style0 from "./breeder-litter-management-component.vue?vue&type=style&index=0&id=8a2f6e70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2f6e70",
  null
  
)

export default component.exports